import { gql } from '@apollo/client';

export const UPDATE_ABSENCE_AVAILABILITY = gql`
	mutation UpdateCrewMemberAbsence($id: ID!, $input: CrewMemberAbsenceInput!) {
		updateCrewMemberAbsence(id: $id, input: $input) {
			... on CrewMemberAbsenceErrorResponse {
				errors
			}
			... on CrewMemberAbsenceSuccessResponse {
				absence {
					fromTimestamp
					toTimestamp
				}
			}
		}
	}
`;
